import { render, staticRenderFns } from "./luckyWheel.vue?vue&type=template&id=c16421b2&scoped=true&"
import script from "./luckyWheel.vue?vue&type=script&lang=js&"
export * from "./luckyWheel.vue?vue&type=script&lang=js&"
import style0 from "./luckyWheel.vue?vue&type=style&index=0&id=c16421b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16421b2",
  null
  
)

export default component.exports